module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-hamburger.9d9a7899.svg";